import { useQuery } from '@apollo/client';
import { graphql } from '../../__generated__';
import { useTimezones } from '../../Common/hooks/useTimezones';

export const doctorCustomerFufillmentsQuery = graphql(`
  query customerFulfillments($customerID: String) {
    fulfilmentsForCustomer(customerID: $customerID) {
      ...OrderFragment
      createdAt
      id
    }
  }
`);

export const useDoctorCustomerFulfillments = (customerID?: string | null | undefined) => {
  const { data, loading } = useQuery(doctorCustomerFufillmentsQuery, {
    variables: { customerID },
    skip: !customerID,
  });

  const { convertUTCDateToUserISO } = useTimezones();

  const orderedProducts = [...(data?.fulfilmentsForCustomer ?? [])]?.sort((a, b) => {
    return convertUTCDateToUserISO(b?.createdAt)?.diff(convertUTCDateToUserISO(a?.createdAt));
  });

  return { orders: orderedProducts, loading };
};
